"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContractHash = exports.deployContract = exports.SmartContract = exports.txHelpers = exports.nep17 = void 0;
const nep17 = __importStar(require("./nep17"));
exports.nep17 = nep17;
const contract_1 = require("./contract");
Object.defineProperty(exports, "SmartContract", { enumerable: true, get: function () { return contract_1.SmartContract; } });
const helpers_1 = require("./helpers");
Object.defineProperty(exports, "deployContract", { enumerable: true, get: function () { return helpers_1.deployContract; } });
Object.defineProperty(exports, "getContractHash", { enumerable: true, get: function () { return helpers_1.getContractHash; } });
const txHelpers = {
    getSystemFee: helpers_1.getSystemFee,
    calculateNetworkFee: helpers_1.calculateNetworkFee,
    setBlockExpiry: helpers_1.setBlockExpiry,
    addFees: helpers_1.addFees,
};
exports.txHelpers = txHelpers;
